<template>
  <v-dialog v-model="dialogVisible" width="348" persistent>
    <DTMFMask :ready="show"
      @close-on-escape="$emit('close-dialpad')"
      @keypress="keyPress($event)"/>
    <v-card>
      <v-card-title>
        <v-icon color="primary">mdi-dialpad</v-icon>
        <v-spacer></v-spacer>
        <v-btn icon small @click="$emit('close-dialpad')">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-card-title>
      <v-container fluid>
        <DialPad :show="true" :is-calling="false"
          @dialpad-keypress="keyPress($event)"/>
      </v-container>
      <v-card-actions>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DialPad from '@/components/dialer/dialpad.vue'
import DTMFMask from './dtmfmask.vue'
import { mapActions } from 'vuex'

export default {
  name: 'active-calls-dialpad',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    callId: {
      type: String,
      required: true
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.show
      },
      set (value) {
        if (!value) this.$emit('close-dialpad')
      }
    }
  },
  components: { DialPad, DTMFMask },
  methods: {
    ...mapActions({ sendDTMF: 'sipua/sendDTMF' }),
    keyPress: function (key) {
      this.sendDTMF({ callid: this.callId, dtmf: key })
    }
  }
}
</script>

<style scoped>
</style>
